import clsx from 'clsx';

import { Asset } from '~modules/media-library/model/Asset';
import { ViewVariant } from '~modules/media-library/model/ViewVariant';

type TeaserTitleProps = Resolve<{
  asset: Asset;
  variant?: ViewVariant;
}>;

export function TeaserTitle({ asset, variant = ViewVariant.DEFAULT }: TeaserTitleProps) {
  // Derived values
  const title = asset.attributes.title;

  return (
    <div
      className={clsx(
        'ml--teaser-title',
        'font-semibold text-base leading-snug overflow-hidden overflow-ellipsis',
        variant === ViewVariant.TILE_LARGE && 'mt-2',
        variant === ViewVariant.TILE_MEDIUM && 'm-2',
        variant === ViewVariant.TILE_SMALL && 'sr-only',
        variant !== ViewVariant.LIST && 'h-10 clamp-2',
        variant === ViewVariant.LIST && 'flex-grow min-w-0 whitespace-nowrap mx-2',
      )}
    >
      <span dangerouslySetInnerHTML={{ __html: title }} />

      {asset.attributes.childCount ? ' (' + asset.attributes.childCount + ')' : null}
    </div>
  );
}
